// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { apis } from './core/apis';
import * as appUtils from './core/appUtils';
import {ConstStatic} from './core/constStatic';
import {HttpServer} from './core/http.server';
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'babel-polyfill';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';


Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(Antd);

Vue.config.productionTip = false;

Vue.prototype.apis = apis.api;
Vue.prototype.appUtils = appUtils;
Vue.prototype.constStatic = ConstStatic;
Vue.prototype.http = HttpServer;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js